import api from './api';

export interface LessonFilter {
    skill?: string;
    page?: number;
    page_size?: number;
    level?: string;
    difficulty?: string;
    key_word?: string;
}

export interface LessonDetail {
    id: number;
    activity_count: number;
    completed_activities: number;
    progress_percentage: number;
    level: string;
    title: string;
    description: string;
    lesson_mode: string;
    xp: number;
    estimated_duration_minutes: number;
    difficulty: string;
    focus: string[];
    grammar_points: string[];
    vocab_points: string[];
    learning_objectives: string[];
    skill: string;
    subtopic: number;
}

export interface LessonListResponse {
    page: number;
    page_size: number;
    count: number;
    results: LessonDetail[];
    skill_counts?: {
        listening: {
            complete?: number;
            incomplete: number;
            total: number;
        };
        reading: {
            complete?: number;
            incomplete: number;
            total: number;
        };
        writing: {
            complete?: number;
            incomplete: number;
            total: number;
        };
        speaking: {
            complete?: number;
            incomplete: number;
            total: number;
        };
        vocabulary: {
            complete?: number;
            incomplete: number;
            total: number;
        };
        grammar: {
            complete?: number;
            incomplete: number;
            total: number;
        };
    }
}

export class SyllabusService {
    static async fetchAiLessons(filters?: LessonFilter): Promise<LessonListResponse> {
        const params = new URLSearchParams();
        for (const [key, value] of Object.entries(filters || {})) {
            if (value) params.append(key, value.toString());
        }

        const response = await api.get(`/syllabus/ai-lessons/?${params.toString()}`);
        return response.data;
    }

    static async fetchLessonById(id: number): Promise<LessonDetail> {
        const response = await api.get(`/syllabus/ai-lessons/${id}/`);
        return response.data;
    }
} 